export default __webpack_public_path__ + "static/media/mail.41664917.png";